import { render, staticRenderFns } from "./planets-icon.svg.vue?vue&type=template&id=0d4a673a&"
import script from "./planets-icon.svg.vue?vue&type=script&lang=js&"
export * from "./planets-icon.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports